import { render, staticRenderFns } from "./GSnsLinkBlock.vue?vue&type=template&id=8d48968e&scoped=true&"
import script from "./GSnsLinkBlock.vue?vue&type=script&lang=ts&"
export * from "./GSnsLinkBlock.vue?vue&type=script&lang=ts&"
import style0 from "./GSnsLinkBlock.vue?vue&type=style&index=0&id=8d48968e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d48968e",
  null
  
)

export default component.exports